import { isNilOrEmpty } from 'utils'

export default function resetFocus(el: HTMLElement) {
  if (isNilOrEmpty(el)) {
    return
  }

  el.focus()
}
